import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=aa06ac8c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "../styles/Home.css?vue&type=style&index=0&id=aa06ac8c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa06ac8c",
  null
  
)

export default component.exports